export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAH0lEQVR42mNgYGD4TyFm+J/GkEYWHjVg1ADqGkAJBgCHyC7ggjcsEAAAAABJRU5ErkJggg=="